module.exports = __webpack_public_path__ + "static/logo-liberty-60eb223284279433dbc0ddf6dbc5baad.png";